import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {TransportStats} from '../model/Entities/TransportStats';

@Injectable()
export class TransportStatsService extends ApiService<TransportStats> {

    protected apiUrl = 'api/transport-stats';

    protected getObjectType(): any {
        return TransportStats;
    }
}



// WEBPACK FOOTER //
// /app/src/services/transport-stats.service.ts